export function isNull(arg: unknown) {
	return arg === null;
}
